// import $ from 'jquery';
import select2 from 'select2';
import tagsInput from 'jquery-tags-input/dist/jquery.tagsinput.min';
import { handleCookieBar } from './cookieBar.js';
import { getCookie } from './cookies.js';
import { showToastAlerts } from './alerts.js';
import { setupMainPageDefaultVoice } from './defaultVoice.js';

const moment = require('moment');
window.moment = moment;
require('tempusdominus-bootstrap-4');

import dragula from 'dragula';
window.dragula = dragula;

const Inputmask = require('inputmask');

$( document ).ready(function() {
console.log('ready');
const isMobile = ('ontouchstart' in document.documentElement && navigator.userAgent.match(/Mobi/))
if(isMobile){
    $('body').addClass('mobile');
} else {
    $('body').addClass('desktop');
}

const $config = $('#js-config');
window.getConfig = (item) => {
    return $config.data(item);
}

function initSelect2(){
    if ($(".select2").length) {
        // Initialize all select2 except default voice select
        $(".select2").not("#default-voice-select").select2({
            width: '100%'
        });
        
        // Initialize tag search after Select2 is ready
        handleSearchByTag();
    }
}
initSelect2();

function handleSelectPlaceholderStyling(){

    function applyPlaceholderClass($_select){
        if($_select.val()){
            $_select.removeClass('select-placeholder');
        } else {
            $_select.addClass('select-placeholder');
        }
    }
    $("select.form-control").each((i, select)=>{
        const $select = $(select);
        applyPlaceholderClass($select);
    });

    $(document).on('change, blur', 'select.form-control', (e)=>{
        applyPlaceholderClass($(e.target));
    });
    $(document).on('click', 'select.form-control', (e)=>{
        $(e.target).removeClass('select-placeholder');
    });

}
handleSelectPlaceholderStyling();

function handleSearchByTag(){
    let $tagSearchSelect = $('#tagSearchSelect');
    if($tagSearchSelect.length && $tagSearchSelect.hasClass('select2-hidden-accessible')){
        // Ensure Select2 is initialized before binding events
        $tagSearchSelect.on('select2:select select2:unselect', (e) => {
            const selectedValues = $tagSearchSelect.select2('val');
            showSongsWithTags(selectedValues || []);
        });
    }
}

function showSongsWithTags(all_used_tags) {
  let lst = document.getElementsByClassName("song");
  for (let piosenka_idx = 0; piosenka_idx < lst.length; piosenka_idx++) {

    var visible = true;
    for (let tag_idx = 0; tag_idx < all_used_tags.length; tag_idx++) {
      if (!lst[piosenka_idx].classList.contains(all_used_tags[tag_idx])) {
        visible = false;
      }
    }
    if (visible) {
      lst[piosenka_idx].classList.remove("d-none");
    } else {
      lst[piosenka_idx].classList.add("d-none");
    }
  }
}

function handleListSearch() {
    let $listSearchInput = $('#listSearchInput');
    if($listSearchInput.length){
        $listSearchInput.on('keyup search', (e) => {
            var input, filter, ul, li, a, i, txtValue;
            input = document.getElementById("listSearchInput");
            filter = input.value.toUpperCase();
            ul = document.getElementById("searchList");
            li = ul.getElementsByClassName("searchItem");
            for (i = 0; i < li.length; i++) {
                a = li[i].getElementsByClassName("searchItemValue")[0];
                txtValue = a.textContent || a.innerText;
                if (txtValue.toUpperCase().indexOf(filter) > -1) {
                    li[i].style.display = "";
                } else {
                    li[i].style.display = "none";
                }
            }
        });
    }
}
handleListSearch();

function handleMultiInput($input, sortable) {

    if ($input.length === 0) {
        return;
    }

  $input.tagsInput({
    'width': '100%',
    'height': '75%',
    'interactive': true,
    'defaultText': '',
    'removeWithBackspace': true,
    'minChars': 0,
    //'maxChars': 20, // if not provided there is no limit
    'placeholderColor': '#6c7293',
    'trimValue': true,
    'delimiter': '|'
  });
}
//handleMultiInput($('#voices'));
handleMultiInput($('#tags'));
handleMultiInput($('#add-user-emails'));


showToastAlerts($('.toast-alert'));

function handleDatepickers(){
    const $datepickers = $('.datepicker');
    if($datepickers.length > 0){
        $datepickers.each(function() {
            const $this = $(this);
            const dateFormat = $this.data('date-format') || 'dd.mm.yyyy'; // Default to dd.mm.yyyy
            
            $this.datepicker({
                todayHighlight: true,
                format: dateFormat,
                autoclose: true,
                language: 'pl' // Polish locale if available
            });
        });
    }
    const $timepickers = $('.timepicker');
    if($timepickers.length > 0){
        $timepickers.datetimepicker({
            format : 'HH:mm',
            icons: {
                up: 'mdi mdi-chevron-up',
                down: 'mdi mdi-chevron-down',
            }
        });
        $('input.datetimepicker-input').blur(()=>{
            $timepickers.datetimepicker('hide');
        })
    }
}
handleDatepickers();

// Make function available globally for dynamic content
window.handleDatepickers = handleDatepickers;

function handleDurationMask(){
    const inputs = document.getElementsByClassName("duration-input");
    Inputmask({ regex: "^[0-2][0-3]:[0-5][0-9]:[0-5][0-9]$" }).mask(inputs);
}
handleDurationMask();

function handleMessageForm(){

    let $form = $('#add-message-form');
    if($form.length > 0){
        let $sendToAllCheckbox = $('input#id_send_to_all', $form);
        let $recipientsChoice = $('.recipients-choice', $form);

        function showHideRecipientsChoice(){
            if($sendToAllCheckbox.is(':checked')) {
                $recipientsChoice.addClass('d-none')
            } else {
                // select2 is broken when initial class is 'd-none'
                $recipientsChoice.removeClass('invisible').removeClass('d-none')
            }
        }

        showHideRecipientsChoice();
        $sendToAllCheckbox.on('change', () => {
            showHideRecipientsChoice();
        });
    }
}
handleMessageForm();


function handleRecurringEvent(){
    let $recurringCheckbox = $('.recurring_button');
    let $recurring_details = $('#recurring_details');
    let $recurringConstantInterval = $('.select_interval')
    let $recurringVariableInterval1 = $('.variable_interval1')
    let $recurringVariableInterval2 = $('.variable_interval2')

    // this function is responsible for hiding the whole part of the form
    function showHideRecurringOptions(){
            if($recurringCheckbox.is(':checked')) {
                $recurring_details.removeClass('d-none')
            } else {
                $recurring_details.addClass('d-none')
            }
        }
    showHideRecurringOptions();
    $recurringCheckbox.on('change', () => {
            showHideRecurringOptions();
        });


    // and this one is responsible for cleaning sections if another section is filled
    $recurringConstantInterval.on('click', () => {
            $recurringVariableInterval1.val("0").change();
            $recurringVariableInterval2.val("9").change();
    });

    $recurringVariableInterval1.on('click', () => {
            $recurringConstantInterval.val("0").change();
    });
    $recurringVariableInterval2.on('click', () => {
            $recurringConstantInterval.val("0").change();
    });

}
handleRecurringEvent();

function markRecentNotificationsAdDisplayed(){
    const $notificationsButton = $('#notificationDropdown');
    const $unreadCount = $('.unread-count', $notificationsButton);
    if($unreadCount.length > 0){
        $notificationsButton.one('click', () => {
            $.post('/api/mark-notifications-as-displayed', {
                'csrfmiddlewaretoken': getCookie('csrftoken'),
                'dateUntil': $notificationsButton.data('date-until')
            }, () => {
                $unreadCount.addClass('d-none');
            });
        });
    }
}
markRecentNotificationsAdDisplayed();

// Prevent confusion when using 'back' button and seeing unread messages notification
function markRecentMessagesAdDisplayed(){
    const $messagesButton = $('#messageDropdown');
    const $unreadCount = $('.unread-count', $messagesButton);
    const $messageItem = $('.new-message', $messagesButton.parent());
    if($unreadCount.length > 0){
        $messageItem.one('click', (e) => {
            let unreadCount = parseInt($unreadCount.text());
            $(e.currentTarget).removeClass('new-message');
            unreadCount--;
            if(unreadCount === 0){
                $unreadCount.addClass('d-none');
            } else {
                $unreadCount.text(unreadCount);
            }
        });
    }
}
markRecentMessagesAdDisplayed();

function loadMoreOnClick($list, feedUrl, feedType, $itemTemplate, fillTemplateWithData){

    if($list.length > 0){

        let allowedQueryFilters = $list.data('allowed-filters');
        if(typeof allowedQueryFilters === 'undefined'){
            allowedQueryFilters = [];
        }

        let queryFilters = {
            'type': feedType
        };
        const urlParams = new URLSearchParams(window.location.search);
        const multiValueFilters = {};

        allowedQueryFilters.forEach((filter) => {
            if (urlParams.has(filter)) {
                if (!multiValueFilters[filter]) {
                    multiValueFilters[filter] = [];
                }
                urlParams.getAll(filter).forEach((value) => {
                    multiValueFilters[filter].push(value);
                });
            }
        });
        Object.keys(multiValueFilters).forEach((key) => {
            queryFilters[key] = multiValueFilters[key];
        });

        let itemsCount = $('.js-list-item', $list).length;
        let allItemsCount = $list.attr('data-list-items-count');
        const $loading = $('#list-items-loading');
        let isLoading = false;
        const $loadMoreWrapper = $('.list-items-load-more', $list);

        if(itemsCount < allItemsCount){
            $loadMoreWrapper.removeClass('d-none');
        }

        $('button', $loadMoreWrapper).on('click', () => {

            if(!isLoading && $list.is(':visible')){
                itemsCount = $('.js-list-item', $list).length;
                allItemsCount = $list.attr('data-list-items-count');

                if(itemsCount < allItemsCount){
                    isLoading = true;
                    $loading.removeClass('d-none');

                    queryFilters['offset'] = parseInt(itemsCount);
                    const queryParams = new URLSearchParams();
                    Object.keys(queryFilters).forEach((key) => {
                        const value = queryFilters[key];
                        if (Array.isArray(value)) {
                            value.forEach((v) => queryParams.append(key, v));
                        } else {
                            queryParams.append(key, value);
                        }
                    });

                    $.get(feedUrl + '?' + queryParams.toString(), (data)=>{
                      $loading.addClass('d-none');
                      data.forEach((itemData)=>{
                        let $newListItem = fillTemplateWithData(itemData, $itemTemplate.clone().removeClass('d-none'));
                        $newListItem.insertBefore($loadMoreWrapper);
//                        $list.append($newListItem);
                      });

                      itemsCount = $('.js-list-item', $list).length;
                      if(itemsCount >= allItemsCount){
                        $loadMoreWrapper.addClass('d-none');
                      }

                      isLoading = false;
                   });
                }
            }
        });
    }
}

const fillEventListItem = (eventData, $template) => {
    $('.event-name', $template).text(eventData.name);
    $('.event-place', $template).text(eventData.place);
    $('.event-url', $template).attr('href', eventData.url);
    $('.event-date', $template).text(eventData.date);
    $('.event-start-hour', $template).text(eventData.start_hour);
    if(eventData.concert){
        $('.event-concert', $template).removeClass('d-none');
    }
    if(!eventData.public){
        $('.event-public', $template).removeClass('d-none');
    }
    return $('.js-list-item', $template);
}
loadMoreOnClick($('#incoming-events'), window.getConfig('events-feed-url'), 'incoming', $('#event-list-item-template'), fillEventListItem);
loadMoreOnClick($('#past-events'), window.getConfig('events-feed-url'), 'past', $('#event-list-item-template'), fillEventListItem);

const fillAnnouncementListItem = (data, $template) => {
    $('.announcement-title', $template).text(data.title);
    $('.announcement-content', $template).html(data.content);
    $('.announcement-start-date', $template).text(data.start_date);
    if(data.is_scheduled){
        $('.announcement-start-date-wrapper', $template).removeClass('d-none');
    }
    $('.announcement-valid-until', $template).text(data.valid_until);
    $('.announcement-added-by', $template).text(data.added_by);
    $('[data-bs-target]', $template).attr('data-bs-target', '#announcement-collapse-' + data.slug);
    $('[aria-controls]', $template).attr('aria-controls', 'announcement-collapse-' + data.slug);
    $('.collapse', $template).attr('id', 'announcement-collapse-' + data.slug);
    if(data.edit_url){
        $('.announcement-edit', $template).attr('href', data.edit_url);
        $('.announcement-delete', $template)
            .attr('data-announcement-slug', data.slug)
            .attr('data-ensembleslug', data.ensemble_slug)
        ;
    }
    return $('.js-list-item', $template);
}
loadMoreOnClick($('#all-announcements-page-list #active-announcements'), window.getConfig('announcements-feed-url'), 'incoming', $('#announcement-list-item-template'), fillAnnouncementListItem);
loadMoreOnClick($('#all-announcements-page-list #inactive-announcements'), window.getConfig('announcements-feed-url'), 'past', $('#announcement-list-item-template'), fillAnnouncementListItem);

const fillVoiceListItem = (data, $template) => {
    $('.voice-name', $template).text(data.name);
    $('a', $template).attr('href', data.url);
    return $('.js-list-item', $template);
}
loadMoreOnClick($('#all-voices'), window.getConfig('voices-feed-url'), 'incoming', $('#voice-list-item-template'), fillVoiceListItem);

const fillSongListItem = (data, $template) => {
    $('.song-name', $template).text(data.name);
    $('.song-composer', $template).text(data.composer);
    $('a', $template).attr('href', data.url);
    if(data.duration){
        $('.song-duration-value', $template).text(data.duration);
        $('.song-duration', $template).removeClass('d-none');
    }
    return $('.js-list-item', $template);
}
loadMoreOnClick($('#all-songs'), window.getConfig('songs-feed-url'), 'incoming', $('#song-list-item-template'), fillSongListItem);

function previousNextKeyboardControl(){
    const next_button = document.getElementById('switch-next')
    const previous_button = document.getElementById('switch-previous')

    if (next_button || previous_button) {
        document.addEventListener("keydown", (e) => {
            const activeElement = document.activeElement;
            if (activeElement.tagName === "TEXTAREA") {
                return;
            }

            if (e.key === 'ArrowRight') {
                next_button.click();
            }
            if (e.key === 'ArrowLeft') {
                previous_button.click();
            }
        });
    };
}

previousNextKeyboardControl();


function mobileNavbarBodyOverlay(){
    const $body = $('body');
    const $sidebarMenu = $('#sidebar');
    const $overlay = $('#overlay');

    $overlay.on('click', function(e){
        $sidebarMenu.removeClass('active');
        $body.removeClass("overlay");
    });

    $('#mobile-menu-toggler').on('click', ()=>{
        $body.toggleClass("overlay");
    });
}
mobileNavbarBodyOverlay();

function submitFormOnlyOnce(){
    const $submitFormOnlyOnce = $('form').not('.form-submit-once-ignore');
    if($submitFormOnlyOnce.length > 0){
        $submitFormOnlyOnce.on('submit', ()=>{
            $('button', $submitFormOnlyOnce).attr('disabled', true);
        });
    }
}
submitFormOnlyOnce();

handleCookieBar();

function handleWelcomeModal(){
    const $welcomeModal = $('#welcomeModal');
    if($welcomeModal.length > 0){
        $welcomeModal.modal('show');
    }
}
handleWelcomeModal();

function handleDefaultVoiceSelection(){
    // Use the shared module for default voice functionality
    const ensembleSlug = $('#default-voice-select').data('ensemble-slug');
    if (ensembleSlug) {
        setupMainPageDefaultVoice(ensembleSlug);
    }
}
handleDefaultVoiceSelection();

});
